import { render, staticRenderFns } from "./Saturacao.vue?vue&type=template&id=53ede280&"
import script from "./Saturacao.vue?vue&type=script&lang=js&"
export * from "./Saturacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports